import clsx from 'clsx'
import React from 'react'

import { FullScreenModal } from 'components/uikit/FullScreenModal/FullScreenModal'

import styles from './FullScreenModal.module.scss'
import { Button } from '../button/Button'
import Cross from '../icons/cross/Cross'

interface FullScreenModalProps {
  title?: string
  text?: string
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  children?: React.ReactNode
  className?: string
  button?: {
    text: string
    onClick: () => void
  }
  closeAction?: () => void
  setIsVideoPlaying?: (playVideo: boolean) => void
}

const CommonFullScreenModal = ({
  title,
  text,
  isOpen,
  setIsOpen,
  children,
  className,
  button,
  closeAction,
  setIsVideoPlaying,
}: FullScreenModalProps) => {
  return (
    <FullScreenModal className={clsx(styles.container, className)} open={isOpen}>
      <div slot="header" className={styles.header}>
        <button
          data-testid="close-button"
          className={styles.closeButton}
          onClick={() => {
            setIsOpen(false)
            closeAction && closeAction()
            setIsVideoPlaying && setIsVideoPlaying(false)
          }}
        >
          <Cross height={32} width={32} color="#4C4C4C" />
        </button>
        {title && <h3 className={styles.title}>{title}</h3>}
        {text && (
          <p className={styles.text}>
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </p>
        )}
      </div>
      <div slot="body" className="flex flex-row items-center justify-center w-full h-full">
        {children}
      </div>
      <div slot="actions">{button && <Button text={button.text} onClick={button.onClick} />}</div>
    </FullScreenModal>
  )
}

export default CommonFullScreenModal
